import { combineReducers } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import authSlice from './modules/auth/auth-slice';
import configSlice from './modules/config/config-slice';
import mainSlice from './modules/main/main-slice';
import { persistConfig } from './index';
import sellingCompaniesSlice from './modules/selling-companies/selling-companies-slice';
import serviceWorkerSlice from './modules/service-worker/service-worker.slice';

const appReducer = combineReducers({
  auth: authSlice,
  main: mainSlice,
  config: configSlice,
  sellingCompanies: sellingCompaniesSlice,
  serviceWorker: serviceWorkerSlice,
});

const rootReducer = (state, action) => {
  // Clear localstorage and authentication related slices on LOGOUT
  if (action.type === 'auth/logout') {
    const { config } = state;
    storage.removeItem(`persist:${persistConfig.key}`);
    // keep only this slice
    state = { config };
  }

  return appReducer(state, action);
};

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
